<template>
  <v-form ref="form" v-model="valid" :lazy-validation="true">
    <div>
        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.name"
              :rules="rules.nameRules"
              label="Name"
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.phone"
              :rules="rules.phoneRules"
              label="Phone"
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="24">
            <v-text-field
              v-model="inputs.email"
              :rules="rules.emailRules"
              label="E-mail"
              required
              :disabled="isProcessing"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="datePicker"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="computedDateFormatted"
                  clearable
                  label="Preferred Date"
                  append-icon="add"
                  readonly
                  v-on="on"
                  :rules="rules.dateRules"
                  required
                  @click:clear="inputs.date = null"
                  @click:append="() => datePicker = true"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="inputs.date"
                dark
                :min="minDate"
                @input="datePicker = false"
                :disabled="isProcessing"
                :allowed-dates="allowedDates"
                color="grey"
                header-color="grey darken-3"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <!--v-menu
              ref="timePicker"
              v-model="isTimePickerOn"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="inputs.time"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              max-width="290px"
              min-width="290px"
              required
            -->
              <!--template v-slot:activator="{ on }">
                <v-text-field
                  v-model="inputs.time"
                  label="Preferred Time"
                  append-icon="add"
                  readonly
                  v-on="on"
                  :rules="rules.timeRules"
                  required
                ></v-text-field>
              </template-->
              <v-select
                :items="getPreferredTime"
                v-model="inputs.time"
                label="Preferred Time"
                append-icon="keyboard_arrow_down"
                :rules="rules.timeRules"
                :disabled="!this.inputs.date || this.isProcessing"
                no-data-text="No available time for this date"
                required
              ></v-select>
              <!--v-time-picker
                v-if="isTimePickerOn"
                v-model="inputs.time"
                :min="minHour"
                :max="maxHour"
                full-width
                dark
                scrollable
                :disabled="!this.inputs.date || this.isProcessing"
                @click:minute="$refs.timePicker.save(inputs.time)"
              ></v-time-picker-->
            <!--/v-menu-->
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="24">
           <v-select
              :items="services"
              v-model="inputs.service"
              label="Select Service"
              append-icon="keyboard_arrow_down"
              :rules="rules.serviceRules"
              :disabled="isProcessing"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="24">
            <v-radio-group
              v-model="inputs.existing_client"
            >
              <v-radio label="New Client" :value="false"/>
              <v-radio label="Existing Client" :value="true"/>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="24">
            <button
              class="gh-button"
              @click.prevent="handleSubmit">
                  <v-progress-circular
                    v-if="isProcessing"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  {{ buttonText }}
            </button>
          </v-col>
        </v-row>
    </div>
    <gh-dialog-alert
      v-if="openDialog"
      :title="dialogTitle"
      :message="dialogMessage"
      :is-open="openDialog"
      :type="dialogType"
      @close="closeDialog"></gh-dialog-alert>
  </v-form>
</template>

<script>

import { format, getDay, isToday, parseISO } from 'date-fns'
import mixinForm from './mixins/form'
import ghDialogAlert from '../dialog/dialog-alert'

  export default {
    name: 'ghFormBooking',

    mixins: [mixinForm],

    components: {
      ghDialogAlert
    },

    props: {
      services: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        valid: false,
        disableTime: false,
        isProcessing: false,
        openDialog: false,
        dialogTitle: '',
        dialogMessage: '',
        dialogType: 'success',
        isSuccess: false,
        inputs: {
          name: '',
          email: '',
          phone: '',
          date: null,
          time: null,
          service: '',
          existing_client: false
        },
        rules: {
          phoneRules: [
            v => !!v || 'Phone is required'
          ],
          nameRules: [
            v => !!v || 'Name is required'
          ],
          emailRules: [
            v => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || 'E-mail must be valid',
          ],
          dateRules: [
            v => !!v || 'Preferred date is required'
          ],
          timeRules: [
            v => !!v || 'Preferred time is required'
          ],
          serviceRules: [
            v => !!v || 'Service is required'
          ]
        },
        datePicker: false,
        isTimePickerOn: false
      }
    },

    computed: {
      buttonText() {
        return this.isProcessing ? 'Submitting' : 'REQUEST BOOKING'
      },
      minDate() {
        return format(new Date(), 'yyyy-MM-dd')
      },

      getWeekDay() {
        return getDay(new Date(this.inputs.date))
      },

      getPreferredTime() {
        let times = []
        if (this.getWeekDay === 0) {
          return times
        } else if (this.getWeekDay === 6) {
          times = [
            { text: '9:00am', value: '09:00'},{ text: '10:00am', value: '10:00'},{ text: '11:00am', value: '11:00'},
            { text: '12:00pm', value: '12:00'},{ text: '1:00pm', value: '13:00'},{ text: '2:00pm', value: '14:00'},
            { text: '3:00pm', value: '15:00'},{ text: '4:00pm', value: '16:00'}
          ]
        } else if (this.getWeekDay === 1) {
          times = [
            { text: '10:00am', value: '10:00'},{ text: '11:00am', value: '11:00'},{ text: '12:00pm', value: '12:00'},
            { text: '1:00pm', value: '13:00'},{ text: '2:00pm', value: '14:00'}
          ]
        } else if (this.getWeekDay === 5) {
          times = [
            { text: '10:00am', value: '10:00'},{ text: '11:00am', value: '11:00'},{ text: '12:00pm', value: '12:00'},
            { text: '1:00pm', value: '13:00'},{ text: '2:00pm', value: '14:00'},{ text: '3:00pm', value: '15:00'},
            { text: '4:00pm', value: '16:00'},{ text: '5:00pm', value: '17:00'},{ text: '6:00pm', value: '18:00'}
          ]
        } else {
          times = [
            { text: '10:00am', value: '10:00'},{ text: '11:00am', value: '11:00'},{ text: '12:00pm', value: '12:00'},
            { text: '1:00pm', value: '13:00'},{ text: '2:00pm', value: '14:00'},{ text: '3:00pm', value: '15:00'},
            { text: '4:00pm', value: '16:00'},{ text: '5:00pm', value: '17:00'},{ text: '6:00pm', value: '18:00'},
            { text: '7:00pm', value: '19:00'},{ text: '8:00pm', value: '20:00'}
          ]
        }

        if (!isToday(parseISO(this.inputs.date))) return times

        const now = new Date()
        const currentHour = now.getHours()

        return times.filter(item => +item.value.replace(':00', '') > currentHour)
      },

      minHour() {
          if(this.getWeekDay !== 6 && this.getWeekDay !== 7) {
            return '10:00'
          }

          return '09:00'
      },

      maxHour() {
        if(this.getWeekDay === 1) {
            return '14:00'
        } else if(this.getWeekDay === 5) {
            return '18:00'
        }
          return '20:00'
      },

      computedDateFormatted () {
        return this.inputs.date ? format(new Date(this.inputs.date), 'dd/LL/yyyy') : ''
      },
    },

    methods: {
      allowedDates: val => {
        return (new Date(val)).getDay() !== 0
      },

      closeDialog () {
        if(this.isSuccess) {
          window.location.href = '/services'
        } else {
          this.openDialog = false
        }
      },

      async processForm () {
        this.isProcessing = true
        this.isSuccess = false

        try {
          await this.$http.post('/contact/bookings', this.inputs)
                .then(res => {
                  this.dialogType = 'success'
                  this.dialogMessage = 'Thank you for your request, the form has been successfully submitted'
                  this.dialogTitle = 'Request Sent'
                  this.isSuccess = true
                }).catch(err => {
                   if (err.response) {
                    if(err.response.data.errors.email) {
                      this.dialogMessage = err.response.data.errors.email[0]
                    }
                  } else {
                    this.dialogMessage = 'Something went wrong. Our service is not available at the moment.'
                  }
                  this.dialogType = 'error'
                  this.dialogTitle = 'Unable to send message'
                })
        } catch (error) {
            this.dialogType = 'error'
            this.dialogTitle = 'Unable to send message'
            this.dialogMessage = 'Something went wrong. Our service is not available at the moment.'
        }
        this.openDialog = true
        this.isProcessing = false
      }
    }
  }
</script>

<style scoped lang="sass">
  .v-text-field
    padding-top: 0

  .v-progress-circular
    margin-right: 1rem
</style>
